import React from 'react';

import { Outlet } from 'react-router-dom';

import MainTopBar from '~/components/MainTopBar/MainTopBar';
import { useAuth } from '~/context/AuthContext';
import { useMainTopBar } from '~/context/MainTopBarContext';

const ProtectedLayout: React.FC = () => {
  const { props } = useMainTopBar();
  const { user, signOut } = useAuth();

  return (
    <div className="flex h-screen flex-col">
      <MainTopBar {...props} user={user} onLogout={signOut} />
      <Outlet />
    </div>
  );
};

export default ProtectedLayout;
